import { Button, styled } from "@mui/material";
import { Result } from "../shared/interfaces/Result";
import { ChangeEvent, useRef } from "react";
import { useImageUpload } from "./useImageUpload";
import AddIcon from "@mui/icons-material/Add";

interface UploadImageButtonProps {
  result: Result;
  captureId: number;
  surveyAssetName: string;
  panelAssetId?: number;
  onUploadSuccess: () => void;
  onUploadError: (response: Response) => Promise<void>;
}

const CenteredButton = styled(Button)({
  marginTop: "30%",
  verticalAlign: "middle",
  minWidth: "25px",
  width: "25px",
  height: "25px",
});

export function UploadImageButton(props: UploadImageButtonProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { mutate: uploadImageFile } = useImageUpload(
    props.result.assetId,
    props.captureId,
    props.result.dataPointId,
    props.surveyAssetName,
    props.panelAssetId,
    {
      onSuccess: props.onUploadSuccess,
      onError: props.onUploadError,
    },
  );

  function handleUploadButtonClick() {
    fileInputRef.current?.click();
  }

  function handleFileChange(event: ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0];
    if (file) {
      uploadImageFile(file);
    }
  }

  return (
    <div>
      <input type="file" accept="image/*" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
      <CenteredButton variant="contained" onClick={handleUploadButtonClick}>
        <AddIcon />
      </CenteredButton>
    </div>
  );
}
